import React from 'react';
import useDecisionTreeInfoContext from '../DecisionTreeInfoContext/useDecisionTreeInfoContext';
import { DecisionTreeExpandedContext } from './useDecisionTreeExpandedContext';

export default function DecisionTreeExpandedContextProvider({ children }: { children: React.ReactNode }) {
  const [expanded, setExpanded] = React.useState<string | undefined>(undefined);

  const { nodeHistory } = useDecisionTreeInfoContext();
  const lastNodeRef = React.useRef(nodeHistory?.slice(-1)[0]?.nodeId);

  React.useEffect(() => {
    if (nodeHistory) {
      if (nodeHistory.slice(-1)[0]?.nodeId !== lastNodeRef.current) {
        setExpanded(nodeHistory.slice(-1)[0]?.nodeId);
      }
    } else {
      setExpanded(undefined);
    }
    lastNodeRef.current = nodeHistory?.slice(-1)[0]?.nodeId;
  }, [nodeHistory]);

  const value = React.useMemo(() => ({
    expanded,
    setExpanded,
  }), [expanded, setExpanded]);

  return (
    <DecisionTreeExpandedContext.Provider value={value}>
      {children}
    </DecisionTreeExpandedContext.Provider>
  );
}
